module.exports = {
    getCountries: function() {
        return [
            {
                "name": "USA",
                "abbreviation": "US"
            }            
        ];
    }
}